module.exports = __webpack_public_path__ + "img/bukopin.e241b3b1.svg";